<template>
  <a-config-provider :locale="zhCN">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'

moment.locale('zh-cn')

export default {
  name: 'App',
  data() {
    return {
      zhCN
    }
  }
}
</script>

<style scoped>
#app {
  height: 100%;
}
</style>
<style>
.ant-layout-content {
  min-height: fit-content !important;
}
</style>
